// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"386":"453a9c8a","445":"13ae3555","635":"c2dc61dd"}[chunkId] + ".chunk.css";
};